module.exports = __webpack_public_path__ + "static/media/Workflow.3ad2ddfe.svg";